<stm-toast-outlet />
<div class="flex min-h-dvh flex-col">
    @if (localPlaywrightHarness()) {
        <main class="min-h-dvh w-full overflow-x-hidden">
            <router-outlet />
        </main>
    } @else if (authRecovery(); as recovery) {
        <div class="flex min-h-full flex-1 items-center justify-center bg-gray-50 p-6" role="alert">
            <div class="max-w-md rounded-lg border border-amber-200 bg-white p-8 shadow-sm">
                <h1 class="mb-2 text-lg font-semibold text-gray-900">Sign-in problem</h1>
                <p class="mb-6 text-sm text-gray-600">{{ recovery.message }}</p>
                <div class="flex flex-wrap gap-3">
                    <button
                        type="button"
                        class="rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                        (click)="retryAuth()">
                        Try sign-in again
                    </button>
                    <button
                        type="button"
                        class="rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                        (click)="reloadApp()">
                        Refresh page
                    </button>
                </div>
            </div>
        </div>
    } @else if (!isLoading()) {
        @if (authenticated()) {
            <stm-main-nav />
            <main class="w-full flex-1 min-h-0 overflow-y-auto">
                <router-outlet></router-outlet>
            </main>
        }
        @else {
            <div class="flex items-center justify-center h-full">
                <div class="text-center">
                    <div class="mb-4">
                        <svg class="animate-spin h-8 w-8 text-blue-600 mx-auto" xmlns="http://www.w3.org/2000/svg" fill="none"
                            viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                            </path>
                        </svg>
                    </div>
                    <p class="text-gray-600">Redirecting to login...</p>
                </div>
            </div>
        }
    }
    @else {
        <div class="flex items-center justify-center h-full">
            <div class="text-center">
                <div class="mb-4">
                    <svg class="animate-spin h-8 w-8 text-blue-600 mx-auto" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                        </path>
                    </svg>
                </div>
                <p class="text-gray-600">Loading application...</p>
            </div>
        </div>
    }
    <footer class="shrink-0 border-t border-slate-200 bg-white px-3 py-1.5 text-xs text-slate-600 sm:px-4 sm:py-2.5 sm:text-sm" aria-label="ASM Group Inc. contact information">
        <div class="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-x-3 gap-y-1 sm:gap-x-5">
            <span class="sr-only font-medium text-slate-700 sm:not-sr-only">Need assistance? Contact ASM Group Inc.</span>
            <a
                href="mailto:trailers@asmgroupinc.com"
                aria-label="Email ASM Group Inc. at trailers@asmgroupinc.com"
                class="text-navy-700 inline-flex min-h-11 items-center gap-1.5 rounded px-0.5 whitespace-nowrap hover:underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 sm:min-h-8 sm:px-0"
            >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" class="h-4 w-4 shrink-0" aria-hidden="true">
                    <rect width="18" height="14" x="3" y="5" rx="2" />
                    <path d="m3 7 9 6 9-6" />
                </svg>
                trailers&#64;asmgroupinc.com
            </a>
            <a
                href="tel:+17632011451"
                aria-label="Call ASM Group Inc. at 763-201-1451"
                class="text-navy-700 inline-flex min-h-11 items-center gap-1.5 rounded px-0.5 whitespace-nowrap hover:underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 sm:min-h-8 sm:px-0"
            >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" class="h-4 w-4 shrink-0" aria-hidden="true">
                    <path
                        d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                    />
                </svg>
                763-201-1451
            </a>
        </div>
    </footer>
</div>
<stm-spinner />
